import React, { createContext, useContext, useState, useEffect } from 'react';

export type Language = 'th' | 'en';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// ไฟล์แปลภาษา
const translations = {
  th: {
    'nav.home': 'หน้าแรก',
    'nav.services': 'บริการของเรา',
    'nav.products': 'ผลิตภัณฑ์',
    'nav.partners': 'พันธมิตร',
    'nav.contact': 'ติดต่อเรา',
    'nav.menu': 'เมนู',
    'nav.close': 'ปิดเมนู',
    'nav.open': 'เปิดเมนู',
    'nav.language': 'ภาษา',
  },
  en: {
    'nav.home': 'Home',
    'nav.services': 'Our Services',
    'nav.products': 'Products',
    'nav.partners': 'Partners',
    'nav.contact': 'Contact Us',
    'nav.menu': 'Menu',
    'nav.close': 'Close Menu',
    'nav.open': 'Open Menu',
    'nav.language': 'Language',
  },
};

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('th');

  // โหลดภาษาจาก localStorage เมื่อเริ่มต้น
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') as Language;
    if (savedLanguage && (savedLanguage === 'th' || savedLanguage === 'en')) {
      setLanguage(savedLanguage);
    }
  }, []);

  // บันทึกภาษาใน localStorage เมื่อเปลี่ยน
  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  // ฟังก์ชันแปลภาษา
  const t = (key: string): string => {
    return translations[language][key as keyof typeof translations[typeof language]] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
